import { orchestrator } from 'satcheljs';
import { updateMergedViewAvailabilityAccountCompleted } from 'owa-truetime';
import setTrueTimeUpdateFailedAccountMutator from '../mutators/setTrueTimeUpdateFailedAccountMutator';
import getAccountPendingTrueTimeUpdate from '../selectors/getAccountPendingTrueTimeUpdate';

orchestrator(updateMergedViewAvailabilityAccountCompleted, ({ userIdentity, updateSuccessful }) => {
    // if there is no account assume it's the account pending truetime update
    const account = userIdentity ? userIdentity : getAccountPendingTrueTimeUpdate();
    setTrueTimeUpdateFailedAccountMutator(updateSuccessful ? null : account);
});
